import { renderRuntimeEnvScriptBody } from "./runtime-env";

/**
 * Server Component that injects `window.__RUNTIME_CONFIG__` from the
 * container's current env vars. Render this once, as early as possible
 * (inside `<head>` of the root layout), in every app so client-side code —
 * primarily the OIDC login/redirect builder in `oidc/config.ts` — resolves
 * host/realm/client-id/API URLs at runtime instead of at build time.
 *
 * @see runtime-env.ts for the full rationale and promotion story.
 */
export function RuntimeEnvScript() {
  return (
    // eslint-disable-next-line react/no-danger -- trusted, server-generated JSON of a small allowlist of env vars.
    <script
      id="runtime-env"
      dangerouslySetInnerHTML={{ __html: renderRuntimeEnvScriptBody() }}
    />
  );
}
